<div *ngIf="products && products.length">
    <p-dataView #dv [value]="products" [paginator]="true" [rows]="9" filterBy="name" *ngIf="dataView" layout="grid"
        [lazy]="true">
        <ng-template pTemplate="header">
            <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                    <i class="pi pi-search"></i>
                    <input type="search" pInputText placeholder="Search by Name"
                        (input)="dv.filter($event.target.value)" />
                </span>
                <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
            </div>
        </ng-template>
        <ng-template let-viewProducts pTemplate="list">
            <div *ngFor="let product of viewProducts" class="p-col-12">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="assestBaseUrl +'images/' + product.img" [alt]="product.name" />
                            <div class="p-mt-2">
                                <strong>{{ product.name }}</strong>
                            </div>
                        </div>
                        <div class="p-d-flex p-flex-column p-text-right">
                            <div>
                                <p-button label="Install Now" (click)="installVendor(product)" *ngIf="
                                        !product.isInstalled &&
                                        !product.showSpin
                                    "></p-button>
                                <span class="pi pi-spin pi-spinner" *ngIf="product.showSpin"></span>
                                <p-button icon="pi pi-check" (click)="uninstallVendor(product)"
                                    *ngIf="product.isInstalled"></p-button>
                            </div>
                            <p-button class="p-mt-auto" label="Details" (click)="getVendorDetails(product)"
                                *ngIf="product.showDetailBtn"></p-button>
                        </div>
                    </div>
                    <div class="p-mt-2 leaddescName" (click)="showMoreInfo(product)">
                        {{
                        product?.description?.length > 22
                        ? (product.description | slice: 0:22) +
                        "... More"
                        : product?.description
                        }}
                    </div>
                </p-card>
            </div>
        </ng-template>
        <ng-template let-viewProducts pTemplate="grid">
            <div class="p-grid">
                <div *ngFor="let product of viewProducts" class="p-col-12 p-md-4">
                    <p-card class="product-item">
                        <div class="p-d-flex p-jc-between">
                            <div class="p-text-center">
                                <img [src]="assestBaseUrl +'images/' + product.img" [alt]="product.name" />
                                <div class="p-mt-2">
                                    <strong>{{ product.name }}</strong>
                                </div>
                            </div>
                            <div>
                                <p-button label="Install Now" (click)="installVendor(product)" *ngIf="
                                        !product.isInstalled && !product.showSpin
                                    "></p-button>
                                <span class="pi pi-spin pi-spinner" *ngIf="product.showSpin"></span>
                                <p-button icon="pi pi-check" (click)="uninstallVendor(product)" *ngIf="product.isInstalled">
                                </p-button>
                            </div>
                        </div>
                        <div class="p-d-flex p-jc-between">
                            <div class="p-my-2 leaddescName" (click)="showMoreInfo(product)">
                                {{
                                product?.description?.length > 22
                                ? (product.description | slice: 0:22) +
                                "... More"
                                : product?.description
                                }}
                            </div>
                            <div>
                                <p-button label="Details" (click)="getVendorDetails(product)" *ngIf="product.showDetailBtn">
                                </p-button>
                            </div>
                        </div>
                    </p-card>
                </div>
            </div>
        </ng-template>
    </p-dataView>
    <div *ngIf="products && products.length">
        <div *ngIf="!dataView">
            <ng-container *ngIf="product?.name?.toLowerCase() == 'easy post'">
                <form [formGroup]="easyPostForm">
                    <div class="p-d-flex">
                        <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
                        <h5 class="p-ml-3 p-mt-1">
                            {{ product.name }} configuration
                        </h5>
                    </div>
                    <p-panel header="Credentials">
                        <p>To enable easypost configuration, you'll need to:</p>
                        <ul>
                            <li>
                                1. Sign up for an
                                <a href="https://www.easypost.com/signup" target="_blank">EasyPost</a>
                                account
                            </li>
                            <li>
                                2. Enter your carrier specific credentials on
                                the Carrier Account Dashboard<br />
                                <span class="p-ml-3"><i>Note: By default, you'll only receive
                                        USPS rates</i></span>
                            </li>
                            <li>
                                3. Find your API keys, use Test key for testing
                                purposes and switch to your Production Key when
                                you are ready to buy real production postages.
                            </li>
                        </ul>
                        <div class="p-grid">
                            <div class="p-col-3">
                                <div class="p-text-right p-mt-1">
                                    Production mode
                                </div>
                            </div>
                            <div class="p-col-9">
                                <p-checkbox formControlName="isProduction" [binary]="true" inputId="binary">
                                </p-checkbox>
                            </div>
                        </div>
                        <div class="p-grid">
                            <div class="p-col-3">
                                <div class="p-text-right p-mt-2" *ngIf="
                                        easyPostForm.controls['isProduction']
                                            .value
                                    ">
                                    Production API key
                                </div>
                                <div class="p-text-right p-mt-2" *ngIf="
                                        !easyPostForm.controls['isProduction']
                                            .value
                                    ">
                                    Test API key
                                </div>
                            </div>
                            <div class="p-col-9">
                                <input class="w-100" type="password" pInputText formControlName="clientSecret" />
                            </div>
                        </div>
                    </p-panel>
                    <p-panel header="Address verification">
                        <div class="p-grid">
                            <div class="p-col-3">
                                <div class="p-text-right p-mt-1">
                                    Address verification
                                </div>
                            </div>
                            <div class="p-col-9">
                                <p-checkbox formControlName="verifyAddress" [binary]="true" inputId="binary">
                                </p-checkbox>
                            </div>
                        </div>
                    </p-panel>
                </form>
                <div class="p-text-right p-mt-3">
                    <p-button label="Save" [disabled]="!easyPostForm.valid" (click)="save()"></p-button>
                </div>
            </ng-container>
            <ng-container *ngIf="product?.name?.toLowerCase() == 'ups'">
                <div class="p-d-flex p-jc-between">
                    <div class="p-d-flex">
                        <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
                        <h5 class="p-ml-3 p-mt-1">
                            {{ product.name }} configuration
                        </h5>
                    </div>
                    <p-button icon="pi pi-plus" (click)="addFedexAccount()"></p-button>
                </div>
                    <p-table [value]="fedexAccounts">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Account Name</th>
                                <th>Account No.</th>
                                <th>License Agreement Status</th>
                                <th>Is Active</th>
                                <th>Is Production</th>
                                <th>Is Default</th>
                                <th>Action</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-data>
                            <tr>
                                <td>{{ data?.accountValue?.accountName }}</td>
                                <td>{{ data?.accountValue?.accountNumber }}</td>
                                <td>
                                    {{ "Com" }}
                                    <a class="pointer" href="https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions.page" target="blank">View
                                        Details</a>
                                </td>
                                <td>
                                    {{data?.accountValue?.isActive ? "Yes" : "No"}}
                                </td>
                                <td>
                                    {{data?.isProduction ? "Yes" : "No"}}
                                </td>
                                <td>
                                    <p-radioButton [disabled]="!data?.accountValue?.isActive" [(ngModel)]="data.isDefault"
                                        (onClick)="changeFedexDefaultAccount(data)" [value]="true"></p-radioButton>
                                    {{data?.isDefault ? "Yes" : "No"}}
                                </td>
                                <td class="action">
                                    <span class="btnBars">
                                        <i class="pi pi-microsoft" (click)="viewFedexAccountDetails(data)"></i>
                                    </span>
                                    <span class="btnBars" *ngIf="!data.isDefault">
                                        <i class="pi pi-trash" (click)="deleteFedexAccount(data)"></i>
                                    </span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                <form [formGroup]="upsForm">
                    <p-panel header="Credentials">
                        <p>
                            To enable {{ product.name }} configuration, you'll
                            need to:
                        </p>
                        <ul>
                            <li>
                                1. Sign up for an
                                <a href="https://www.ups.com/doapp/signup?loc=en_US" target="_blank">{{ product.name
                                    }}</a>
                                account
                            </li>
                            <li>
                                2. Enter your carrier specific credentials on
                                the Carrier Account Dashboard<br />
                                <span class="p-ml-3"><i>Note: By default, you'll only receive
                                        USPS rates</i></span>
                            </li>
                            <li>
                                3. Find your API keys, use Test key for testing
                                purposes and switch to your Production Key when
                                you are ready to buy real production postages.
                            </li>
                        </ul>
                        <div class="p-grid">
                            <div class="p-col-3">
                                <div class="p-text-right p-mt-1">
                                    Production mode
                                </div>
                            </div>
                            <div class="p-col-2">
                                <p-checkbox formControlName="isProduction" [binary]="true" inputId="binary">
                                </p-checkbox>
                            </div>
                            <div class="p-col-7">
                                <p-button label="Enable Sandbox" (click)="configure(product.name)" *ngIf="!upsForm.value.isProduction"></p-button>
                                <p-button label="Enable Production" (click)="configure(product.name)" *ngIf="upsForm.value.isProduction"></p-button>
                            </div>
                        </div>
                    </p-panel>
                    <p-panel header="Address verification">
                        <div class="p-grid">
                            <div class="p-col-3">
                                <div class="p-text-right p-mt-1">
                                    Address verification
                                </div>
                            </div>
                            <div class="p-col-9">
                                <p-checkbox formControlName="verifyAddress" [binary]="true" inputId="binary">
                                </p-checkbox>
                            </div>
                        </div>
                    </p-panel>
                </form>
                <div class="p-text-right p-mt-3">
                    <p-button label="Save" [disabled]="!upsForm.valid" (click)="saveUpsIsProdAndAddressVerifyInfo()">
                    </p-button>
                </div>
            </ng-container>
            <ng-container *ngIf="product?.name?.toLowerCase() == 'fedex'">
                <div class="p-d-flex p-jc-between">
                    <div class="p-d-flex">
                        <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
                        <h5 class="p-ml-3 p-mt-1">
                            {{ product.name }} configuration
                        </h5>
                    </div>
                    <p-button icon="pi pi-plus" (click)="addFedexAccount()"></p-button>
                </div>
                <p-table [value]="fedexAccounts">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Account Name</th>
                            <th>Account No.</th>
                            <th>License Agreement Status</th>
                            <th>Is Active</th>
                            <th>Is Production</th>
                            <th>Is Default</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data>
                        <tr>
                            <td>{{ data?.accountValue?.accountName }}</td>
                            <td>{{ data?.accountValue?.accountNumber }}</td>
                            <td>
                                {{ "Com" }}
                                <a class="pointer" href="https://developer.fedex.com/api/en-us/legal/fdpla.html"
                                    target="blank">View Details</a>
                            </td>
                            <td>
                                {{data?.accountValue?.isActive ? "Yes" : "No"}}
                            </td>
                            <td>
                                {{data?.isProduction ? "Yes" : "No"}}
                            </td>
                            <td>
                                <p-radioButton [disabled]="!data?.accountValue?.isActive" [(ngModel)]="data.isDefault"
                                    (onClick)="changeFedexDefaultAccount(data)" [value]="true"></p-radioButton>
                                {{data?.isDefault ? "Yes" : "No"}}
                            </td>
                            <td class="action">
                                <span class="btnBars">
                                    <i class="pi pi-microsoft" (click)="viewFedexAccountDetails(data)"></i>
                                </span>
                                <span class="btnBars" *ngIf="!data.isDefault">
                                    <i class="pi pi-trash" (click)="deleteFedexAccount(data)"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <form [formGroup]="fedexForm">
                    <p-panel header="Credentials">
                        <p>
                            To enable {{ product.name }} configuration, you'll
                            need to:
                        </p>
                        <ul>
                            <li>
                                1. Sign up for an
                                <a href="https://www.fedex.com/register/#/contact" target="_blank">FedEx</a>
                                account
                            </li>
                            <li>
                                2. Enter your carrier specific credentials on
                                the Carrier Account Dashboard<br />
                                <span class="p-ml-3"><i>Note: By default, you'll only receive
                                        USPS rates</i></span>
                            </li>
                            <li>
                                3. Find your API keys, use Test key for testing
                                purposes and switch to your Production Key when
                                you are ready to buy real production postages.
                            </li>
                        </ul>
                        <div class="p-grid">
                            <div class="p-col-3">
                                <div class="p-text-right p-mt-1">
                                    Production mode
                                </div>
                            </div>
                            <div class="p-col-2">
                                <p-checkbox [binary]="true" inputId="binary" formControlName="isProduction">
                                </p-checkbox>
                            </div>
                            <div class="p-col-7">
                                <p-button label="Enable Production" *ngIf="val"></p-button>
                            </div>
                        </div>
                    </p-panel>
                    <p-panel header="Address verification">
                        <div class="p-grid">
                            <div class="p-col-3">
                                <div class="p-text-right p-mt-1">
                                    Address verification
                                </div>
                            </div>
                            <div class="p-col-9">
                                <p-checkbox formControlName="verifyAddress" [binary]="true" inputId="binary">
                                </p-checkbox>
                            </div>
                        </div>
                    </p-panel>
                </form>
                <div class="p-text-right p-mt-3">
                    <p-button label="Save" (click)="saveFedexIsProdAndAddressVerifyInfo()"></p-button>
                </div>
            </ng-container>
        </div>

        <p-dialog header="{{dialogHeader}}" [(visible)]="displayAddFedexData" [modal]="true" [responsive]="true"
            [style]="{ width: '60vw' }">
            <form [formGroup]="fedexAddressForm">
                <div class="header">
                    <h5>
                        Shipping Account Information
                        <p-inputSwitch class="header-switch" formControlName="isActive"></p-inputSwitch>
                    </h5>
                </div>
                <div class="card">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <label>Account Name <span style="color: red">*</span></label>
                            <input type="text" pInputText formControlName="accName" />
                        </div>
                        <div class="p-col-12 p-md-6">
                            <label>{{accNoLabel}} <span style="color: red">*</span></label>
                            <input type="text" pInputText formControlName="accNo" />
                        </div>
                        <div class="p-col-12 p-md-6">
                            <label>Is Production<span style="color: red">*</span></label>
                            <p-radioButton name="ia" value="Yes"
                                [formControl]="fedexAddressForm.controls['isProduction']" inputId="Yes" label="Yes">
                            </p-radioButton>
                            &nbsp;&nbsp;
                            <p-radioButton name="ia" value="No"
                                [formControl]="fedexAddressForm.controls['isProduction']" inputId="No" label="No">
                            </p-radioButton>
                        </div>
                    </div>
                </div>
                <div class="header">
                    <h5>Company Billing Address</h5>
                </div>
                <div class="card">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <label>Street 1 <span style="color: red">*</span></label>
                            <lion-gm-place-autocomplete
                                [formattedAddress]="addressInput"
                                (onRemoveAddress)="removeAddressLocation()"
                                (onAddressChange)="locationAddresChanged($event)"
                                (onSettingAddrress)="onAddressBlur($event)"
                                [disabled]="isDisabled">
                            </lion-gm-place-autocomplete>
                            <small class="p-invalid">{{ ErrorMessageSetLocation }}</small>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <label>Street 2 (Option)</label>
                            <input pInputText type="text" [(ngModel)]="streetAddress2"
                                [ngModelOptions]="{ standalone: true }" [disabled]="isDisabled" />
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <label>City</label>
                            <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="city"
                                placeholder="Select a City" [(ngModel)]="selectedCity" [filter]="true"
                                optionLabel="name" [disabled]="isDisabled"></p-dropdown>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <label>State</label>
                            <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="states"
                                placeholder="Select a State" [(ngModel)]="selectedState" [filter]="true"
                                optionLabel="name" (onChange)="getCitiesFromState($event.value)"
                                [disabled]="isDisabled">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <label>Country</label>
                            <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="country"
                                optionLabel="name" [(ngModel)]="selectedCountry" placeholder="Select a Country"
                                [filter]="true" (onChange)="getStatesFromCountry($event.value)" [disabled]="isDisabled">
                            </p-dropdown>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <label>Zipcode</label>
                            <input pInputText type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="zipCode"
                                [disabled]="isDisabled" />
                        </div>
                    </div>
                </div>
                <div class="p-grid">
                    <div class="p-col-12">
                        <div class="p-field-checkbox">
                            <p-checkbox [(ngModel)]="agreed" [binary]="true" inputId="binary"
                                [ngModelOptions]="{ standalone: true }" [disabled]="isDisabled"></p-checkbox>
                            <label for="binary">I have read the {{shippingProvider}}
                                <a class="pointer" *ngIf="shippingProvider=='FedEx'" href="https://developer.fedex.com/api/en-us/legal/fdpla.html"
                                    target="blank">End User License Agreement</a>
                                    <a class="pointer" *ngIf="shippingProvider=='UPS'" href="https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions.page"
                                    target="blank">End User License Agreement</a>.</label>
                        </div>
                    </div>
                </div>
            </form>
            <p-footer>
                <button type="button" pButton (click)="displayAddFedexData = false" label="Cancel"
                    class="p-button-secondary"></button>
                <button type="button" pButton label="Save" (click)="saveFedexAccountInfo()"
                    [disabled]="!agreed || !fedexAddressForm.valid || isDisabled"></button>
            </p-footer>
        </p-dialog>
    </div>
</div>
